import { render, staticRenderFns } from "./EventRegistrationsComponent.vue?vue&type=template&id=7cea0d09&scoped=true&"
import script from "./EventRegistrationsComponent.vue?vue&type=script&lang=js&"
export * from "./EventRegistrationsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cea0d09",
  null
  
)

export default component.exports